import React from "react";

export default function AppLogo({ isMobile }) {
  return (
    <div
      style={{
        position: "absolute",
        bottom: isMobile ? 50 : 10,
        fontSize: isMobile ? "8px" : "12px",
        right: isMobile ? 20 : null,
        left: isMobile ? null : 60,
        zIndex: 10,
        textAlign: "center",
        color: "#000000",
        fontFamily: "sans-serif",
        opacity: 1,
      }}
    >
      <img
        src="/albert.png"
        alt="Albert Genau"
        style={{ height: isMobile ? 33 : 150, objectFit: "contain", marginBottom: 4 }}
      />
      {!isMobile && (<div>© 2026 AlbertGenau</div>)}
    </div>
  );
}